"use client";

import * as React from "react";
import { Card, Text } from "@hubble/web";
import { Colors } from "themes/color-palette";
import { useTranslations } from "i18n";
import { FILES } from "i18n/constants";
import { Link } from "i18n/routing";

const EURiskSummary = () => {
  const t = useTranslations(FILES.PRICES);
  return (
    <Card customBgColor={Colors.blue[50]} mb={9} variant="filled">
      <Text.Heading marketing size="xxs" color={Colors.blue[500]} mb={1}>
        {t("riskSummaryTitleMiCA")}
        <Text.Body size="sm" marketing color={Colors.blue[500]}>
          {t("riskSummaryDescriptionMiCA")}
        </Text.Body>
      </Text.Heading>
      <Text.Heading marketing size="xxs" color={Colors.blue[500]} mb={1}>
        {t("riskSummaryTitle2MiCA")}
        <Text.Body size="sm" marketing color={Colors.blue[500]}>
          {t("riskSummaryDescription2MiCA")}
        </Text.Body>
      </Text.Heading>
      <Text.Heading marketing size="xxs" color={Colors.blue[500]} mb={1}>
        {t("riskSummaryTitle3MiCA")}
        <Text.Body size="sm" marketing color={Colors.blue[500]}>
          {t("riskSummaryDescription3MiCA")}
        </Text.Body>
      </Text.Heading>
      <Text.Body size="sm" marketing color={Colors.blue[500]}>
        {t("riskSummaryDescription4MiCA")}
        <Link
          href={"https://www.gemini.com/legal/eu-sustainability-transparency"}
        >
          {t("riskSummaryDescription4LinkMiCA")}
        </Link>
        .
      </Text.Body>
    </Card>
  );
};

export default EURiskSummary;
